import React, {
  Component,
  PropTypes
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {} from '../actions/';

class ErrorContainer extends Component {
  render() {
    const { actions } = this.props;
    return <div>
      Error
    </div>;
  }
}

ErrorContainer.propTypes = {
  actions: PropTypes.shape({})
};

function mapStateToProps(state) {
  const props = {};
  return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {};
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorContainer);



// WEBPACK FOOTER //
// ./containers/ErrorContainer.js